import { combineReducers } from 'redux';
import { passengersReducer } from './passengers/reducers';
import { formIsLockedReducer } from './formIsLocked/reducers';
import { priceBreakdownReducer } from './priceBreakdown/reducers';
import { orderReducer } from './order/reducers';
import { orderPriceReducer } from './orderPrice/reducers';
import { selectedServicesReducer } from './selectedServices/reducers';
import { servicesIsSavingReducer } from './servicesIsSaving/reducers';
import { loadingServicesParamsReducer } from './loadingServicesParams/reducers';
import { seatMapReducer } from '../../SeatMap/store/reducers';
import { everyPortServicesReducer } from './everyPortServices/reducers';
import { everyTravelReducer } from './everyTravel/reducers';
import { exchangeReducer } from '@entities/exchange';
import { errorReducer } from '@entities/error';
import { default as subsidiesReducer } from './subsidies/reducers';
import errorMessageReducer from './errorMessage/reducers';
import { orderReducer as newOrderReducer } from '@entities/order';
import { refundReducer } from '@entities/refund';
export const rootReducer = combineReducers({
    order: orderReducer,
    newOrder: newOrderReducer,
    passengers: passengersReducer,
    formIsLocked: formIsLockedReducer,
    priceBreakdown: priceBreakdownReducer,
    orderPrice: orderPriceReducer,
    selectedServices: selectedServicesReducer,
    servicesIsSaving: servicesIsSavingReducer,
    seatMap: seatMapReducer,
    loadingServiceParams: loadingServicesParamsReducer,
    everyPort: everyPortServicesReducer,
    everyTravel: everyTravelReducer,
    error: errorReducer,
    subsidies: subsidiesReducer,
    errorMessage: errorMessageReducer,
    exchange: exchangeReducer,
    refund: refundReducer
});
